/* Copyright (c) 2026 Xperi. All Rights Reserved. */

enum CarouselTemplate {
  /**
   * Displays full content artwork (16:9).
   * Used in carousels (e.g. Home page).
   * NOTE: Does NOT switch to PIP video on focus.
   */
  LANDSCAPE_HORIZONTAL = "landscape_horizontal",

  /**
   * Same as landscape horizontal but supports navigation to a grid view.
   * Includes a "See More" tile at the end of the carousel.
   * Clicking "See More" opens a full grid page.
   */
  LANDSCAPE_GRID = "landscape_grid",

  /**
   * 16:9 tile with PIP behaviour.
   * Showcases series/movie artwork or sports head-to-head.
   * On focus, tile converts into a PIP video.
   */
  PIP_LANDSCAPE_HORIZONTAL = "pip_landscape_horizontal",

  /**
   * 16:9 tile with Logo and PIP behaviour.
   * Identifier for Recently Watched Channels carousel.
   * Displays logo first and then on focus uses PIP.
   */
  LOGO_PIP_LANDSCAPE_HORIZONTAL = "logo_pip_landscape_horizontal",

  /**
   * Same as PIP landscape horizontal with additional grid navigation.
   * Includes a "See More" tile leading to a grid page.
   */
  PIP_LANDSCAPE_GRID = "pip_landscape_grid",

  /**
   * Poster-style tile (2:3).
   * Used for showcasing series or movies.
   * Example: "Top 10 for You" carousel.
   */
  POSTER_HORIZONTAL = "poster_horizontal",

  /**
   * Square-style usage (1:1) for logos.
   * Displays channel / league / team logos.
   */
  LOGO_HORIZONTAL = "logo_horizontal"
}

export { CarouselTemplate };
